import React from 'react';
import {
  Grid,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  Stack,
  Typography,
  CircularProgress,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Scrollbar from '../scrollbar';
import { SETTINGS_TABLE_HEAD } from '../../utils/leaveConstants';

const LeaveSettingsTable = ({
  leaveSettings,
  isLoading,
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  onView,
  onEdit,
  onDelete,
}) => {
  return (
    <Grid item xs={12}>
      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <TableHead>
                <TableRow>
                  {SETTINGS_TABLE_HEAD.map((headCell) => (
                    <TableCell key={headCell.id} align={headCell.alignRight ? 'right' : 'left'}>
                      {headCell.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={SETTINGS_TABLE_HEAD.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : leaveSettings.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={SETTINGS_TABLE_HEAD.length} align="center">
                      <Typography variant="body2" color="text.secondary">
                        No leave settings found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  leaveSettings.map((setting) => (
                    <TableRow hover key={setting.id}>
                      <TableCell>{setting.employee.full_name}</TableCell>
                      <TableCell>{setting.sick_leaves_per_annum}</TableCell>
                      <TableCell>{setting.casual_leaves_per_annum}</TableCell>
                      <TableCell>{setting.earned_leaves_per_annum}</TableCell>
                      <TableCell>{setting.maternity_leaves_per_annum}</TableCell>
                      <TableCell>{setting.paternity_leaves_per_annum}</TableCell>
                      <TableCell>{setting.unpaid_leaves_per_annum}</TableCell>
                      <TableCell>{setting.other_leaves_per_annum}</TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={1}>
                          <IconButton size="small" onClick={() => onView(setting)}>
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton size="small" onClick={() => onEdit(setting)}>
                            <EditIcon />
                          </IconButton>
                          <IconButton size="small" onClick={() => onDelete(setting)} color="error">
                            <DeleteIcon />
                          </IconButton>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      </Card>
    </Grid>
  );
};

export default LeaveSettingsTable;
